import { UserIcon } from '@library/components/avatar/UserIcon';
import { cn } from '@library/component-utils/cn';

interface AvatarProps {
  className?: string;
  googleAvatarUrl?: string;
}

export const Avatar = ({
  className = '',

  googleAvatarUrl = undefined
}: AvatarProps) => {
  return (
    <div
      className={cn(
        'flex size-10 items-center justify-center rounded-full',
        className
      )}
    >
      <UserIcon googleAvatarUrl={googleAvatarUrl} />
    </div>
  );
};
